import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent } from '@mui/material'
import { CardTitle } from '../../../../components/card/NewCard'
import { hasLocalisationStation } from 'utils/StationUtils'
import CartographyPanel from 'components/map/CartographyPanel'
import i18n from 'simple-react-i18n'
import { getI18nTitleData } from 'utils/StringUtil'

const DashboardMapPanel = ({
    stationType,
    data = {},
}) => {
    const stationsWithCoordinates = data.stations.filter(s => s && (hasLocalisationStation(s) || s.townCode))
    return (
        <Card>
            <CardTitle
                title={(
                    <>
                        <span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{data?.title}</span>
                        <span style={{ fontSize: '1.4rem', fontWeight: 'normal' }}>&nbsp;{`(${data?.stations?.length} ${getI18nTitleData(i18n.element, i18n.elements, data?.stations)})`}</span>
                    </>
                )}
            />
            <CardContent>
                <CartographyPanel
                    layers={['STATIONS_POINTS']}
                    componentType={stationType}
                    stationsPoints={stationsWithCoordinates}
                    stationsPanelTitle={i18n.stations}
                    heightToSubstract={450}
                />
            </CardContent>
        </Card>
    )
}

DashboardMapPanel.propTypes = {
    stationType: PropTypes.string,
    data: PropTypes.shape({
        stations: PropTypes.arrayOf(PropTypes.shape({})),
        title: PropTypes.string,
    }),
}

export default DashboardMapPanel